module.exports = __webpack_public_path__ + "img/ai-en.66b9cc1.png";